export enum LoyaltyTagMultiUpdateResultErrorCode {
  DUPLICATED_TICKER = "DUPLICATED_TICKER",
  TICKER_NOT_FOUND = "TICKER_NOT_FOUND",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
}

export interface LoyaltyTagMultiUpdateResultErrorProps {
  ticker: string;
  code: LoyaltyTagMultiUpdateResultErrorCode;
  message: string;
}

export interface LoyaltyTagMultiUpdateResultProps {
  created: number;
  deleted: number;
  errors: LoyaltyTagMultiUpdateResultErrorProps[];
}

export class LoyaltyTagMultiUpdateResult {
  readonly created: number;
  readonly deleted: number;
  readonly errors: LoyaltyTagMultiUpdateResultError[];

  private constructor(props: LoyaltyTagMultiUpdateResultProps) {
    this.created = props.created;
    this.deleted = props.deleted;
    this.errors = props.errors.map(LoyaltyTagMultiUpdateResultError.of);
  }

  static of(props: LoyaltyTagMultiUpdateResultProps): LoyaltyTagMultiUpdateResult {
    return new LoyaltyTagMultiUpdateResult(props);
  }
}

export class LoyaltyTagMultiUpdateResultError {
  readonly ticker: string;
  readonly code: LoyaltyTagMultiUpdateResultErrorCode;
  readonly message: string;

  private constructor(ticker: string, code: LoyaltyTagMultiUpdateResultErrorCode, message: string) {
    this.ticker = ticker;
    this.code = code;
    this.message = message;
  }

  static of(props: LoyaltyTagMultiUpdateResultErrorProps): LoyaltyTagMultiUpdateResultError {
    return new LoyaltyTagMultiUpdateResultError(props.ticker, props.code, props.message);
  }
}
